export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';


